import { Component } from '@angular/core';
import { DialogBaseViewComponent, Field, PaymentErrorDialogData, Scope } from '@sb/library/base';

export class PaymentErrorDialogScope extends Scope {
    PaymentErrorDismissed = Field<() => void>();
}

@Component({
    selector: 'lib-payment-error-dialog',
    templateUrl: './payment-error-dialog.component.html'
})
export class PaymentErrorDialogComponent extends DialogBaseViewComponent<PaymentErrorDialogData> {

    Scope = this.SetScope({
        Requires: PaymentErrorDialogScope
    });

    override PrimaryAction() {
        super.PrimaryAction();
        this.DismissAction();
        this.Scope.PaymentErrorDismissed();
    }
}
